export const svgURL = (
  entityName: string = "",
  // the isDarkBackground flag indicates whether or not to use the light version of the logo, which is used in dark background
  isDarkBackground: boolean = true
) => {
  return `https://branding.fanrally.com/logos/${entityName}${
    isDarkBackground ? "_dark" : ""
  }.svg`;
};
